var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _path8, _path9, _path0, _rect4, _line, _line2, _line3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvertenkaccountgraded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 246,
    viewBox: "0 0 402 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.824 17.2251H342.196V24.5971H334.824V17.2251Z",
    fill: "#1E334E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.195 16.6609H286.567V24.0328H279.195V16.6609ZM297.356 3.58008V25.6061H316.685V3.58008H297.356Z",
    fill: "#F58120"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M365.506 35.6504H372.878V87.0745H365.506V35.6504ZM347.525 165.559V185.607H366.09V165.559H347.525ZM366.045 215.005V194.957H347.48V215.005H366.045Z",
    fill: "#528FF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278.007 154.568L248.115 186.124C244.698 182.888 242.046 180.37 240.563 178.977C229.775 168.728 220.694 164.637 208.827 164.637C204.917 164.637 201.32 165.087 197.904 166.031C188.779 168.548 178.98 165.806 172.462 158.929C159.741 145.488 165 123.462 182.396 117.169C190.667 114.202 199.567 112.584 208.827 112.584C238.9 112.584 264.971 129.62 278.007 154.568Z",
    fill: "#528FF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.041 215.073C212.737 215.073 211.524 214.398 210.849 213.185L205.32 202.756C204.376 201.003 205.051 198.845 206.804 197.901C208.557 196.957 210.714 197.632 211.658 199.385L215.524 206.622L218.356 205.094L214.49 197.856C213.906 196.733 213.951 195.339 214.625 194.26C215.299 193.181 215.659 191.923 215.659 190.664C215.659 187.023 212.692 183.966 209.096 183.877C207.793 183.832 206.669 183.112 206.04 181.989L185.047 142.611L179.024 145.803C177.271 146.747 175.113 146.073 174.169 144.32C173.225 142.567 173.899 140.409 175.653 139.465L184.823 134.565C186.576 133.621 188.733 134.296 189.677 136.049L211.479 176.954C217.997 178.168 222.851 183.877 222.851 190.709C222.851 192.597 222.492 194.44 221.727 196.193L226.402 204.959C226.852 205.813 226.942 206.802 226.672 207.701C226.402 208.6 225.773 209.364 224.919 209.813L215.704 214.623C215.165 214.893 214.58 215.073 214.041 215.073ZM248.114 189.72C247.215 189.72 246.316 189.406 245.641 188.731C244.203 187.383 244.158 185.09 245.507 183.652L303.044 122.878L302.235 121.799C280.434 92.2212 245.507 74.6004 208.782 74.6004C172.101 74.6004 137.174 92.2662 115.328 121.799L114.519 122.878L172.146 183.652C173.495 185.09 173.45 187.383 172.012 188.731C170.573 190.08 168.281 190.035 166.932 188.596L107.282 125.62C106.068 124.361 105.978 122.428 107.012 120.99L109.619 117.484C132.769 86.1079 169.899 67.3633 208.871 67.3633C247.844 67.3633 284.929 86.1079 308.079 117.484L310.686 120.99C311.72 122.383 311.585 124.316 310.416 125.62L250.721 188.596C250.002 189.361 249.058 189.72 248.114 189.72ZM160.189 114.023C158.886 114.023 157.672 113.348 156.998 112.135L149.761 98.5144C148.817 96.7613 149.491 94.6037 151.244 93.6597C152.997 92.7157 155.155 93.39 156.099 95.1431L163.336 108.763C164.28 110.516 163.606 112.674 161.853 113.618C161.358 113.888 160.774 114.023 160.189 114.023ZM248.249 109.123C247.664 109.123 247.08 108.988 246.54 108.718C244.787 107.774 244.113 105.617 245.057 103.864L252.294 90.2434C253.238 88.4903 255.396 87.816 257.149 88.76C258.902 89.704 259.576 91.8616 258.632 93.6147L251.395 107.235C250.766 108.449 249.552 109.123 248.249 109.123ZM203.612 100.582C201.634 100.582 200.016 98.9639 200.016 96.9861V81.5229C200.016 79.545 201.634 77.9268 203.612 77.9268C205.59 77.9268 207.208 79.545 207.208 81.5229V96.9861C207.208 98.9639 205.59 100.582 203.612 100.582Z",
    fill: "#F58120"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.495 205.162L218.318 217.758L229.339 211.985L224.091 202.014C225.665 196.591 226.085 185.43 215.169 184.17L192.602 141.661L181.057 147.959",
    stroke: "#1E334E",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.334 186.794L118.605 122.771C130.037 105.803 165.139 71.7625 214.1 71.3427C275.301 70.8179 305.374 105.978 316.981 122.771L256.308 186.794",
    stroke: "#1E334E",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 203.074,
    y: 78.1348,
    width: 6.34726,
    height: 22.0914,
    rx: 3,
    stroke: "#1E334E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 255.964,
    y: 89.5057,
    width: 6.34726,
    height: 22.0914,
    rx: 3,
    transform: "rotate(28.5197 255.964 89.5057)",
    stroke: "#1E334E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.200596,
    y: 0.678057,
    width: 6.34726,
    height: 22.0914,
    rx: 3,
    transform: "matrix(-0.878653 0.477461 0.477461 0.878653 151.831 94.2537)",
    stroke: "#1E334E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.109,
    cy: 10.9272,
    r: 8.99608,
    stroke: "#528FF5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.7695,
    cy: 195.658,
    r: 15.7441,
    fill: "#F58120"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.825,
    cy: 68.6555,
    r: 9.44648,
    fill: "#F58120"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.007 223.806H15.4961C12.7347 223.806 10.4961 226.045 10.4961 228.806V240.204C10.4961 242.966 12.7347 245.204 15.4961 245.204H360.408C363.17 245.204 365.408 242.966 365.408 240.204V228.806C365.408 226.045 363.17 223.806 360.408 223.806H232.759C231.517 223.806 230.32 224.268 229.401 225.102L224.747 229.319C223.828 230.153 222.631 230.615 221.39 230.615H153.776C152.603 230.615 151.467 230.202 150.568 229.449L145.216 224.971C144.316 224.219 143.18 223.806 142.007 223.806Z",
    stroke: "#1E334E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4512 228.669H16.4512V229.669V232.882H18.4512V230.669H150.853L158.724 239.329L159.022 239.657H159.464H231.099H231.565L231.865 239.299L239.106 230.669H372.74V232.882H374.74V229.669V228.669H373.74H238.639H238.173L237.873 229.027L230.633 237.657H159.906L152.035 228.997L151.738 228.669H151.295H17.4512Z",
    fill: "#F58120"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0762 43.1113H287.442C230.277 66.7955 114.69 51.4328 93.9596 86.6391C77.3753 114.804 53.1272 124.833 43.0762 126.326V47.1113C43.0762 44.9022 44.867 43.1113 47.0762 43.1113Z",
    fill: "#528FF5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0898,
    y: 37.6675,
    width: 294.566,
    height: 185.639,
    rx: 6.5,
    stroke: "#1E334E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.293,
    y1: 164.72,
    x2: 55.1285,
    y2: 164.72,
    stroke: "black",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 176.265,
    x2: 44.6332,
    y2: 176.265,
    stroke: "black",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 399.984,
    y1: 115.566,
    x2: 368.091,
    y2: 149.392,
    stroke: "#1E334E",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.235,
    cy: 119.562,
    r: 7.97128,
    stroke: "#F58120",
    strokeWidth: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.028,
    cy: 145.802,
    r: 7.97128,
    stroke: "#F58120",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvertenkaccountgraded);
export default __webpack_public_path__ + "static/media/overtenkaccountgraded.c4a219fe3e01a391845e6276fe5a383e.svg";
export { ForwardRef as ReactComponent };